import animImg from "../../../assets/anim-img.svg";
import coralogixImg from "../../../assets/coralogix-logo.svg";
import singularImg from "../../../assets/singular-logo.svg";
import nimbleImg from "../../../assets/nimble-logo.svg";
import moengageImg from "../../../assets/moengage-logo.svg";
import clevertopImg from "../../../assets/clevertop-logo.svg";

export default function TrustedBy() {
  return (
    <>
      <section id="trusted_by">
        <div className="container">
          <div className="trusted-wrapper">
            <div className="trusted-wrapper-img-anim">
              <img src={animImg} alt="img" />
            </div>
            <div className="trusted-logo-wrapper">
              <h4>Trusted By</h4>
              <p>
                Built by the team who’ve hired dozens of technical and
                go-to-market professionals for:
              </p>
              <div className="logo-wrapper">
                <img src={coralogixImg} alt="logo" />
                <img src={singularImg} alt="logo" />
                <img src={nimbleImg} alt="logo" />
                <img src={moengageImg} alt="logo" />
                <img src={clevertopImg} alt="logo" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
